const MARKDOWN_LINK_PREFIX = '['

export function normalizeEditorCommitText(text: string): string {
  return autoFormatBareLinks(normalizeLineBreaks(text))
}

function normalizeLineBreaks(text: string): string {
  return text.replace(/\r\n?/g, '\n')
}

function autoFormatBareLinks(text: string): string {
  let output = ''
  let cursor = 0

  while (cursor < text.length) {
    const markdownLink = parseMarkdownLink(text, cursor)
    if (markdownLink) {
      output += markdownLink.raw
      cursor = markdownLink.end
      continue
    }

    const nextMarkdownStart = text.indexOf(MARKDOWN_LINK_PREFIX, cursor + 1)
    const nextBoundary = nextMarkdownStart >= 0 ? nextMarkdownStart : text.length
    output += replaceBareUrls(text.slice(cursor, nextBoundary))
    cursor = nextBoundary
  }

  return output
}

function replaceBareUrls(text: string): string {
  return text.replace(/\bhttps?:\/\/[^\s<>\[\]{}]+/g, (match) => {
    const { url, trailing } = splitTrailingUrlPunctuation(match)
    if (!isSafeHref(url)) return match
    return `[${url}](${url})${trailing}`
  })
}

function splitTrailingUrlPunctuation(match: string): { url: string, trailing: string } {
  let url = match
  let trailing = ''

  while (url.length > 0 && /[.,!?;:]/.test(url[url.length - 1])) {
    trailing = url[url.length - 1] + trailing
    url = url.slice(0, -1)
  }

  while (url.endsWith(')') && countChars(url, ')') > countChars(url, '(')) {
    trailing = ')' + trailing
    url = url.slice(0, -1)
  }

  return { url, trailing }
}

function countChars(value: string, target: string): number {
  let count = 0
  for (let i = 0; i < value.length; i++) {
    if (value[i] === target) count += 1
  }
  return count
}

function parseMarkdownLink(text: string, start: number): { raw: string, end: number } | undefined {
  if (text[start] !== '[') return undefined
  const closeLabel = text.indexOf(']', start + 1)
  const openHref = closeLabel >= 0 ? text.indexOf('(', closeLabel + 1) : -1
  const closeHref = openHref >= 0 ? text.indexOf(')', openHref + 1) : -1
  if (closeLabel <= start + 1 || openHref !== closeLabel + 1 || closeHref <= openHref + 1) {
    return undefined
  }
  const href = text.slice(openHref + 1, closeHref).trim()
  if (!isSafeHref(href)) return undefined
  return {
    raw: text.slice(start, closeHref + 1),
    end: closeHref + 1,
  }
}

function isSafeHref(href: string): boolean {
  const lower = href.trim().toLowerCase()
  return lower.startsWith('http://') || lower.startsWith('https://')
}
